import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-25a52312"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "profile-page" }
const _hoisted_2 = { class: "page-title" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "page-title-text-area" }
const _hoisted_5 = { class: "with-subhead" }
const _hoisted_6 = {
  key: 0,
  class: "subhead"
}
const _hoisted_7 = { class: "nav-item" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { class: "nav-item" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    id: "matchesTab",
    class: "nav-link",
    "data-bs-toggle": "tab",
    "data-bs-target": "#matchesPane",
    role: "tab",
    "aria-controls": "matchesPane",
    "aria-selected": "false"
  }, " Matches ")
], -1))
const _hoisted_9 = { class: "nav-item" }
const _hoisted_10 = {
  type: "button",
  id: "contentTab",
  class: "nav-link",
  "data-bs-toggle": "tab",
  "data-bs-target": "#contentPane",
  role: "tab",
  "aria-controls": "contentPane",
  "aria-selected": "false"
}
const _hoisted_11 = {
  key: 0,
  class: "count"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { class: "nav-item" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    id: "sharingTab",
    class: "nav-link",
    "data-bs-toggle": "tab",
    "data-bs-target": "#sharingPane",
    role: "tab",
    "aria-controls": "sharingPane",
    "aria-selected": "false"
  }, " Sharing ")
], -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { class: "nav-item" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    id: "manageTab",
    class: "nav-link",
    "data-bs-toggle": "tab",
    "data-bs-target": "#managePane",
    role: "tab",
    "aria-controls": "managePane",
    "aria-selected": "false"
  }, " Manage ")
], -1))
const _hoisted_14 = { class: "tab-content content-area" }
const _hoisted_15 = {
  id: "personPane",
  class: "tab-pane show active",
  role: "tabpanel",
  "aria-labelled-by": "personTab",
  "tab-index": "0"
}
const _hoisted_16 = { class: "person-view-options" }
const _hoisted_17 = { class: "btn-group" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "showMatchDataChk",
  class: "btn btn-outline-secondary btn-sm"
}, " Show match data ", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Details", -1))
const _hoisted_20 = {
  id: "matchesPane",
  class: "tab-pane",
  role: "tabpanel",
  "aria-labelledby": "matchesTab",
  "tab-index": "0"
}
const _hoisted_21 = {
  id: "contentPane",
  class: "tab-pane",
  role: "tabpanel",
  "aria-labelledby": "contentTab",
  "tab-index": "0"
}
const _hoisted_22 = {
  id: "sharingPane",
  class: "tab-pane relation-secton",
  role: "tabpanel",
  "aria-labelledby": "sharingTab",
  "tab-index": "0"
}
const _hoisted_23 = {
  id: "managePane",
  class: "tab-pane",
  role: "tabpanel",
  "aria-labelled-by": "manageTab",
  "tab-index": "0"
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" Profiles of living or recently living people are automatically "),
  /*#__PURE__*/_createElementVNode("b", null, "restricted"),
  /*#__PURE__*/_createTextVNode(" when you upload your tree. They are only visible to the tree owner. However, at the same time, a linked copy is created that can be managed and shared separately from the tree. Linked profiles are updated automatically whenever the tree profile they are linked to changes. ")
], -1))

import { computed, ref, watch } from 'vue'
import { areProfileRelationshipsLoaded, loadProfileRelationshipsAsync } from './ProfilePageDataLoader'
import { useDataGroupStore } from '@/gp/DataGroupStore'
import { useUserStore } from '@/gp/UserStore'
import { usePersonStore } from '@/rd/PersonStore'
import { useViewPersonStore } from '@/rd/ViewPersonStore'
import { useContentStore } from '@/rd/ContentStore'
import { useContentTagStore } from '@/rd/ContentTagStore'
import { genderImages, dottedPersonImage } from '@/rd/ResearchDataModel'
import { CompositeId } from '@/rd/CompositeId'
import { ItemType } from '@/rd/ResearchDataModel'
import { usePageTitle } from '@/util/AppUtil'
import { ProfileType, ProfileUtils } from './ProfileUtils'
import { LinkIcon, LockIcon } from '@zhuowenli/vue-feather-icons'
import { useTokenManager } from '@/auth/TokenManager'
import { Tab } from 'bootstrap'
import { useTabsTelemetry } from '@/util/TabTelemetry'
import { LoadMode } from '@/util/AsyncData'
import UserLink from '@/manage/users/UserLink.vue'
import ProfileMatchesEditor from './ProfileMatchesEditor.vue'
import ProfileRelationships from './ProfileRelationships.vue'
import ProfileSharingEditor from './ProfileSharingEditor.vue'
import AssertionList from '@/explore/AssertionList.vue'
import Modal from '@/util/Modal.vue'
import ContentEditor from '@/manage/content/ContentEditor.vue'
import ProfileManager from './ProfileManager.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'ProfilePage',
  props: {
    personId: {}
  },
  setup(__props: any) {

const props = __props;



//const pageDataRef = ref<ProfilePageData>()
const showMatchDataRef = ref(false)

const tabsElemRef = ref<HTMLElement>()
const personTabRef = ref<HTMLButtonElement>()

const dataGroupStore = useDataGroupStore()
const personStore = usePersonStore()
const viewPersonStore = useViewPersonStore()
const userStore = useUserStore()
const contentStore = useContentStore()
const contentTagStore = useContentTagStore()
const tokenManager = useTokenManager()

// Async data (primary)
const personIdRef = computed(() => props.personId ?? dataGroupStore.getAsyncGroup(tokenManager.current.userProfileId)?.data?.startItemId)
const groupIdRef = computed(() => CompositeId.getGroupId(personIdRef.value!))
const asyncPersonRef = computed(() => personStore.getAsyncPerson(personIdRef.value, LoadMode.EnsureLoaded))
const asyncViewPersonRef = computed(() => viewPersonStore.getAsyncPerson(personIdRef.value, LoadMode.EnsureLoaded))
const asyncDataGroupRef = computed(() => dataGroupStore.getAsyncGroup(groupIdRef.value, LoadMode.EnsureLoaded))

// Loaded data
const personRef = computed(() => asyncPersonRef.value?.data)
const viewPersonRef = computed(() => asyncViewPersonRef.value?.data)
const dataGroupRef = computed(() => asyncDataGroupRef.value?.data)

// Loading state
const relationshipsLoadedRef = computed(() => areProfileRelationshipsLoaded(personIdRef.value!))
const detailsLoadedRef = computed(() => viewPersonRef.value && viewPersonStore.areDetailsLoaded(viewPersonRef.value?.id))
const dataLoadedRef = computed(() => [
  asyncPersonRef.value,
  asyncViewPersonRef.value,
  asyncDataGroupRef.value,
].every(a => a?.isLoadComplete()) && 
  relationshipsLoadedRef.value && 
  detailsLoadedRef.value)

// Complex loading
watch(relationshipsLoadedRef, async (loaded) => {
  if (personIdRef.value && !loaded) {
    await loadProfileRelationshipsAsync(personIdRef.value)
  }
}, { immediate: true })
watch(detailsLoadedRef, async (loaded) => {
  if (viewPersonRef.value && !loaded) {
    await viewPersonStore.ensureDetailsLoadedAsync(viewPersonRef.value.id!)
  }
}, { immediate: true })

// Lazy-loaded data
const tagsRef = computed(() => contentTagStore.getTagsForItems(ItemType.Person, [personIdRef.value], LoadMode.EnsureLoaded))

// Computed values
const genderClassRef = computed(() => [personRef.value?.displayProperties.gender?.toLowerCase()])
const personImageUrlRef = computed(() => personImageContentRef.value?.galleryUrl)
const placeholderImageUrlRef = computed(() => personRef.value?.restricted ? dottedPersonImage :
  genderImages[personRef.value?.displayProperties?.gender ?? "default"])
const personImageSrcRef = computed(() => personImageUrlRef.value ?? placeholderImageUrlRef.value)
const personImageContentRef = computed(() => {
  const contentId = personRef.value?.displayProperties?.primaryPhotoSignedUrl?.contentId
  return contentStore.getLoadedContents([contentId]).at(0)
})
const titleRef = computed(() => personRef.value?.displayName ?? "Unknown name")
const ownerRef = computed(() => userStore.getLoadedUser(dataGroupRef.value?.ownerId)) // loaded with group
const profileTypeTextRef = computed(() => ProfileUtils.getProfileSubtitle(profileTypeRef.value))
const profileTypeRef = computed(() => ProfileUtils.getProfileType(personRef.value, dataGroupRef.value, ownerRef.value))

usePageTitle("Profile", () => personRef.value?.displayName)
useTabsTelemetry(tabsElemRef)

watch(personIdRef, () => {
  // reset interactive state
  showMatchDataRef.value = false
  if (personTabRef.value) {
    new Tab(personTabRef.value).show()
  }
}, { immediate: true })


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: _normalizeClass(["gender-bar", genderClassRef.value])
      }, null, 2),
      _createElementVNode("img", {
        src: personImageSrcRef.value,
        class: _normalizeClass(["person-image", { present: personImageUrlRef.value }])
      }, null, 10, _hoisted_3),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("h1", _hoisted_5, _toDisplayString(titleRef.value), 1),
        (profileTypeRef.value)
          ? (_openBlock(), _createElementBlock("p", _hoisted_6, [
              (profileTypeRef.value == _unref(ProfileType).ManagedLinked)
                ? (_openBlock(), _createBlock(_unref(LinkIcon), {
                    key: 0,
                    size: "1x"
                  }))
                : _createCommentVNode("", true),
              (profileTypeRef.value == _unref(ProfileType).ResearchRestricted)
                ? (_openBlock(), _createBlock(_unref(LockIcon), {
                    key: 1,
                    size: "1x"
                  }))
                : _createCommentVNode("", true),
              _createTextVNode(" " + _toDisplayString(profileTypeTextRef.value) + " ", 1),
              (ownerRef.value)
                ? (_openBlock(), _createBlock(UserLink, {
                    key: 2,
                    userId: ownerRef.value?.id,
                    dimmed: ""
                  }, null, 8, ["userId"]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ]),
      (personRef.value)
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 0,
            to: personRef.value.viewPersonUrl,
            class: "btn btn-outline-primary btn-sm explore-link"
          }, {
            default: _withCtx(() => [
              _createTextVNode(" View in family tree ")
            ]),
            _: 1
          }, 8, ["to"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("ul", {
      ref_key: "tabsElemRef",
      ref: tabsElemRef,
      class: "nav nav-pills profile-tabs"
    }, [
      _createElementVNode("li", _hoisted_7, [
        _createElementVNode("button", {
          type: "button",
          id: "personTab",
          ref_key: "personTabRef",
          ref: personTabRef,
          class: "nav-link active",
          "data-bs-toggle": "tab",
          "data-bs-target": "#personPane",
          role: "tab",
          "aria-controls": "personPane",
          "aria-selected": "true"
        }, " Person ", 512)
      ]),
      _hoisted_8,
      _createElementVNode("li", _hoisted_9, [
        _createElementVNode("button", _hoisted_10, [
          _createTextVNode(" Photos & Files "),
          (tagsRef.value.length > 0)
            ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(tagsRef.value.length), 1))
            : _createCommentVNode("", true)
        ])
      ]),
      _hoisted_12,
      _hoisted_13
    ], 512),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("section", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _withDirectives(_createElementVNode("input", {
              type: "checkbox",
              id: "showMatchDataChk",
              class: "btn-check",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((showMatchDataRef).value = $event))
            }, null, 512), [
              [_vModelCheckbox, showMatchDataRef.value]
            ]),
            _hoisted_18
          ])
        ]),
        (personIdRef.value)
          ? (_openBlock(), _createBlock(ProfileRelationships, {
              key: 0,
              "person-id": personIdRef.value,
              "owner-only": !showMatchDataRef.value
            }, null, 8, ["person-id", "owner-only"]))
          : _createCommentVNode("", true),
        _hoisted_19,
        _createVNode(AssertionList, {
          "person-id": personIdRef.value,
          "include-related": "",
          "include-restricted": "",
          "dim-other-owners": "",
          "show-counts": "",
          "owner-only": !showMatchDataRef.value
        }, null, 8, ["person-id", "owner-only"])
      ]),
      _createElementVNode("section", _hoisted_20, [
        _createVNode(ProfileMatchesEditor, { "person-id": personIdRef.value }, null, 8, ["person-id"])
      ]),
      _createElementVNode("section", _hoisted_21, [
        _createVNode(ContentEditor, {
          "item-type": _unref(ItemType).Person,
          "item-id": personIdRef.value
        }, null, 8, ["item-type", "item-id"])
      ]),
      _createElementVNode("section", _hoisted_22, [
        (personIdRef.value)
          ? (_openBlock(), _createBlock(ProfileSharingEditor, {
              key: 0,
              "person-id": personIdRef.value
            }, null, 8, ["person-id"]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("section", _hoisted_23, [
        _createVNode(ProfileManager, { "person-id": personIdRef.value }, null, 8, ["person-id"])
      ])
    ]),
    _createVNode(Modal, {
      id: "explainRestrictedModal",
      title: "Restricted profiles",
      info: ""
    }, {
      default: _withCtx(() => [
        _hoisted_24
      ]),
      _: 1
    })
  ]))
}
}

})